import { useEffect } from "react"
import { useLocation, Navigate, Outlet, useParams, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { useRefreshTokenMutation } from '../../../store/api/endpoints/selfApiSlice'

import { setCredentials, getUsuarioToken } from "../../../store/slices/auth"
import { getStatusSidebar } from "../../../store/slices/sidebar"

import Sidebar from "../Sidebar"

const RequireAuth = () => {

    const navigate = useNavigate()
    const urlParams = useParams()
    const location = useLocation()

    const [refreshToken, { isLoading }] = useRefreshTokenMutation()
    const dispatch = useDispatch()

    const usarTokenDeLocalstorage = async () => {
        try {
            const userData = await refreshToken(localStorage.getItem("token")).unwrap()
            dispatch(setCredentials(userData))
        } catch (err) {
            localStorage.removeItem("token")
            navigate("/login")
        }
    }

    const token = useSelector(getUsuarioToken)

    useEffect(() => {
        if (localStorage.getItem("token")) {
            usarTokenDeLocalstorage()
        } else {
            localStorage.removeItem("token")
            navigate("/login")
        }
    }, [token])

    const statusSidebar = useSelector(getStatusSidebar)
    

    if( token ) return (<><Sidebar /><div id="routesContainer" className={(!statusSidebar ? 'extendido' : '')}><div id="contenedor"><Outlet /></div></div></>)
}

export default RequireAuth